// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-inline[data-v-47db23a4] {\n  width: 100%;\n  display: flex;\n}\n.is-inline .form-item-style[data-v-47db23a4] {\n  display: inline-block;\n}\n.is-division-line[data-v-47db23a4] {\n  line-height: 33px;\n  vertical-align: top;\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
